<template>
    <div>

        <p>
            Type

            <b-select v-model="type" :options="[
                { text: 'Scraping', value: 'scrape' },
                { text: 'Extraction', value: 'extract' },
                { text: 'Recherche', value: 'search'},
                { text: 'Script', value: 'script'}
            ]"></b-select> 
        </p>

        <div v-show="type == 'script'">
            <ace_editor ref="script" :height="300"></ace_editor>
            Fonctions :
            <p>
                async request_scrape(url, prompt, schema, types)<br />
                ex: data.result = await request_scrape("https://smartmydata.com", null, null, ["html"]);
            </p>
            <p>
                async get_in_url(result)<br />
                ex: data.result = await get_in_url(data.result)<br />
                Prend en paramètre le résultat de request_scrape et met le markdown et le html dans des urls
            </p>
        </div>
        <div v-show="type != 'script'">
            <p v-show="type != 'search'">
                Colonne des urls
                <b-input :list="'columns' + id" v-model="column" />
                <datalist :id="'columns' + id">
                    <option v-for="(option, idx) in columns_data" :key="'c' + idx">{{ option }}</option>
                </datalist>      
            </p>

            <p>
                Préfixe des colonnes de résultat
                <b-input v-model="column_result" />
            </p>

            <div v-if="type == 'scrape'">
                Types de résultats
                <b-checkbox-group v-model="type_result" :disabled="!!type_result_column" :options="[
                    { text: 'Markdown', value: 'markdown' },
                    { text: 'HTML', value: 'html' },
                    { text: 'HTML brut', value: 'rawHtml' },
                    { text: 'Liens', value: 'links' },
                    { text: 'Capture de la page', value: 'screenshot' },
                    { text: 'Capture de la page entière', value: 'screenshot@fullPage' },
                    { text: 'JSON', value: 'json' }
                ]"></b-checkbox-group>
                <div class="mt-1">
                    Colonne contenant les types
                    <b-button style="padding:1px" variant="link" v-b-tooltip.hover title="JSON dans la colonne, ex: [&quot;markdown&quot;, &quot;json&quot;]. Types disponibles : markdown, html, rawHtml, links, screenshot, screenshot@fullPage, json"><i class="fas fa-info"></i></b-button>
                    <b-input :list="'trc' + id" v-model="type_result_column" placeholder="Nom de la colonne (optionnel)" />
                    <datalist :id="'trc' + id">
                        <option v-for="(option, idx) in columns_data" :key="'trc' + idx">{{ option }}</option>
                    </datalist>
                </div>
            </div>

            <div v-if="type == 'search'">
                Types de résultats
                <b-button style="padding:1px" variant="link" v-b-tooltip.hover title="Types disponibles : markdown, html, rawHtml, links, screenshot, screenshot@fullPage"><i class="fas fa-info"></i></b-button>
                <b-checkbox-group v-model="type_result" :disabled="!!type_result_column" :options="[
                    { text: 'Markdown', value: 'markdown' },
                    { text: 'HTML', value: 'html' },
                    { text: 'HTML brut', value: 'rawHtml' },
                    { text: 'Liens', value: 'links' },
                    { text: 'Capture de la page', value: 'screenshot' },
                    { text: 'Capture de la page entière', value: 'screenshot@fullPage' }
                ]"></b-checkbox-group>
                <div class="mt-1">
                    Colonne contenant les types
                    <b-button style="padding:1px" variant="link" v-b-tooltip.hover title="JSON dans la colonne, ex: [&quot;markdown&quot;, &quot;json&quot;]. Types disponibles : markdown, html, rawHtml, links, screenshot, screenshot@fullPage"><i class="fas fa-info"></i></b-button>
                    <b-input :list="'trc2' + id" v-model="type_result_column" placeholder="Nom de la colonne (optionnel)" />
                    <datalist :id="'trc2' + id">
                        <option v-for="(option, idx) in columns_data" :key="'trc2' + idx">{{ option }}</option>
                    </datalist>
                </div>
            </div>

            <div v-show="type_result.includes('html') || type_result.includes('markdown') || type_result.includes('rawHtml') || type_result_column">
                <b-checkbox style="display:inline-block" v-model="get_in_url"></b-checkbox>
                Récupérer le html et markdown dans des fichiers
            </div>
            
            <div v-show="(type != 'search' && type_result.includes('json')) || type == 'search'">
                <textarea_plus ref="request" :columns="columns_data"></textarea_plus>
            </div>

            <div v-show="type != 'search' && type_result.includes('json')">
                <p>Schéma</p>
                <json_schema_editor :show_start_array="true" ref="editor" />

                <p>
                    Extraire les résultats
                    <b-checkbox v-model="split_result" />
                </p>
            </div>

            <div v-show="type == 'search'">
                <p>
                    Nombre de résultats
                    <b-select v-model="limit" :options="[1,2,3,4,5,6,7,8,9,10]" />
                </p>
                <p>
                    Langue
                    <b-input v-model="lang" />
                </p>
                <p>
                    Pays
                    <b-input v-model="country"/>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
    import uniqueId from "lodash.uniqueid";

    import json_schema_editor from "../json_schema_editor.vue";
    import workers_service from "../../services/workers.js"
    import edit_tabulator from "../edit_tabulator.vue";
    import textarea_plus from '../textarea_plus.vue';
	import library from "../../services/library.js";
	import ace_editor from "../ace_editor.vue";

    var clone = require("clone");
    
    export default {
        name: "firecrawl",
		components: {
            edit_tabulator,
            textarea_plus,
            json_schema_editor,
            ace_editor
		},
		props: {
            treatment_params: {
                default: false
            },
            files: {
                default: () => []
            },
			data: {
				default: () => [],
            },
			client: {
				default: null
            },
            size: {
                default: 1000
            },
			step_position: {
				default: 0
			}
        },
        watch: 
        {
            data: {
                deep: true,
                immediate: true,
                handler()
                {
                    if (this.data.length != 0)
                    {
                        this.columns_data = Object.keys(this.data[0]);
                    }
                }
            },
            files: {
                deep: true,
                immediate: true,
                handler()
                {
                    //console.log(this.files);

                    if (this.files.length > 0)
                    {
                        var self = this;
                        var reader = new FileReader();

                        reader.onload = (function (theFile) {
                            return function (e) {
                                if (e.target.result)
                                {
                                    var data = self.$papa.parse(e.target.result, { header: true });
                                    if (data.data && data.data.length > 0)
                                    {
                                        self.columns_data = Object.keys(data.data[0]);
                                    }
                                }
                            };
                        })(this.files[0].file ? this.files[0].file : this.files[0]);

                        reader.readAsText(this.files[0].file ? this.files[0].file : this.files[0]);
                    }
                }
            }
        },
        computed: {
            
        },
		data() {
			return {
                id: uniqueId(""),
                column: "",
                column_result: "",
                type: "scrape",
                type_result: [],
                type_result_column: "",
                split_result: false,
                columns_data: [],
                lang: "fr",
                country: "fr",
                limit: 10,
                get_in_url: false
			};
        },
        methods: {
            get_data()
            {
                return this.save()
            },
            save()
            {
                console.log("save");

                var data = {
                    script: this.$refs.script ? this.$refs.script.save() : "",
                    request: this.$refs.request ? this.$refs.request.get_data() : "",
                    schema: this.$refs.editor.get_data(),
                    column: this.column,
                    column_result: this.column_result,
                    type_result: this.type_result,
                    type_result_column: this.type_result_column || "",
                    type: this.type,
                    split_result: this.split_result,
                    limit: this.limit,
                    country: this.country,
                    lang: this.lang,
                    get_in_url: this.get_in_url
                }

                return data;
            },
            async load(data)
            {
                var self = this;
                
                if (!data)
                {
                    return;
                }

                this.column = data.column;
                this.column_result = data.column_result;
                this.split_result = data.split_result || false;
                this.limit = data.limit || 10;
                this.country = data.country || "fr";
                this.lang = data.lang || "fr";
                this.get_in_url = data.get_in_url || false;
                this.type_result_column = data.type_result_column || "";

                if (data.type_result)
                    this.type_result = data.type_result;

                this.type = data.type ? data.type : "scrape";
           
                this.$nextTick(() => {
                        self.$refs.request.load(data.request)
                        self.$refs.editor.load(data.schema)
                        if (data.script)
                            self.$refs.script.load(data.script)
                })

            },
        },
        async mounted()
        {
        }
    }
</script>

<style scoped>
</style>